import React, { useRef } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

interface CertificateProps {
  name: string;
  certificateNumber: string;
  imageUrl: string;
}

const CertificateGenerator: React.FC<CertificateProps> = ({ name, certificateNumber, imageUrl }) => {
  const certificateRef = useRef<HTMLDivElement>(null);

  const generatePDF = async () => {
    if (!certificateRef.current) return;

    const canvas = await html2canvas(certificateRef.current, {
      scale: 3,       // higher resolution
      useCORS: true,  // allow external SVG/image rendering
    });

    const imgData = canvas.toDataURL('image/jpeg', 1.0); // JPEG at max quality

    const pdf = new jsPDF('landscape', 'px', [canvas.width, canvas.height]);
    pdf.addImage(imgData, 'JPEG', 0, 0, canvas.width, canvas.height);
    pdf.save(`${name}_Certificate.pdf`);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        ref={certificateRef}
        style={{
           position: 'relative',
          width: '2000px',
          height: '1414px',              // match image aspect ratio
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'contain',     // show full image without cropping
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        {/* Student Name */}
        <div
          style={{
            position: 'absolute',
            top: '52%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '48px',
            fontWeight: 400,
            color: '#ffffff',
            fontFamily: 'Ubuntu, sans-serif',
            letterSpacing: '0.3px',
          }}
        >
          {name}
        </div>

        {/* Course Name */}
        <div
          style={{
            position: 'absolute',
            top: '62%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '32px',
            fontWeight: 400,
            color: '#ffffff',
            fontFamily: 'Ubuntu, sans-serif',
            letterSpacing: '0.3px',
          }}
        >
          Marketing
        </div>

        {/* Certificate Number */}
        <div
          style={{
            position: 'absolute',
            top: '10%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '32px',
            color: '#333',
            fontFamily: 'Ubuntu, sans-serif',
          }}
        >
          Certificate No: {certificateNumber}
        </div>
      </div>

      <button
        onClick={generatePDF}
        style={{
          marginTop: '20px',
          backgroundColor: 'white',
          color: 'black',
          border: '1px solid #ccc',
          padding: '10px 20px',
          borderRadius: '6px',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        Download PDF
      </button>
    </div>
  );
};

export default CertificateGenerator;
